export interface IThemeState {
  theme: string;
}

export const initialThemeState: IThemeState = {
  theme: 'light',
};
